// Dominio pubblico mostrato ai clienti (link menù, QR, embed, condivisione)
export const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL || window.location.origin).replace(/\/$/, "");
export const menuLink = (slug) => `${PUBLIC_URL}/${slug}`;
